module.exports = __webpack_public_path__ + "static/media/lang-de.11bc5cf7.svg";